import * as React from 'react';
import { useThumbOverlap } from 'react-range';
import { formatMoney } from '../../utils/objects';

const ThumbLabel = ({ rangeRef, values, index, isPrice }) => {
  const [labelValue, labelStyle] = useThumbOverlap(rangeRef, values, index, 1, ' ∼ ', value => {
    if (isPrice) return `${formatMoney(parseInt(value), 0, 0)}m&#178;`;
    return `$${formatMoney(parseInt(value), 0, 0)}`;
  });
  return (
    <div
      data-label={index}
      style={{
        display: 'block',
        position: 'absolute',
        whiteSpace: 'nowrap',
        padding: '0 10px',
        border: 'solid 1px #990000',
        borderRadius: 7,
        color: '#990000',
        background: 'rgba(255, 255, 255, 0.95)',
        fontSize: 16,
        left: '50%',
        transform: 'translateX(-50%)',
        top: '-35px',
        ...labelStyle,
      }}
      className="range-label"
      dangerouslySetInnerHTML={{ __html: labelValue || '' }}
    ></div>
  );
};

export default ThumbLabel;
